export default __webpack_public_path__ + "static/media/logo.7479ff15.svg";